(() => {
    function addScriptTag(scriptOrUrl, id, defer) {
        const el = document.createElement("script")
        el.type = "text/javascript";
        if (isUrl(scriptOrUrl)) {
            el.src = scriptOrUrl;
        } else {
           el.innerText = scriptOrUrl;
        }
        el.id = id;
        if (defer === true) {
            el.defer = true;
        }
        document.head.appendChild(el);
    }

    function isUrl(str) {
        try {
            new URL(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    window.Dashboard = window.Dashboard || {};
    window.Dashboard.helpers = window.Dashboard.helpers || {};
    window.Dashboard.helpers.addScriptTag = addScriptTag;
})();
